import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{appData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{appData.subtitle}</p>
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">{appData.description}</p>
            <div className="flex flex-wrap gap-2">
              {appData.features.map((feat, i) => (
                <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
                  <i className="ri-check-line text-sm"></i>
                  {feat}
                </span>
              ))}
            </div>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <div className="relative">
              <div className="w-56 h-56 md:w-64 md:h-64 bg-background-100 rounded-2xl border-2 border-background-200/70 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto bg-foreground-900 rounded-xl flex items-center justify-center mb-3">
                    <i className="ri-smartphone-line text-background-50 text-3xl"></i>
                  </div>
                  <p className="text-xs text-foreground-500 font-medium">{appData.qrLabel}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}